<template>
    <b-overlay :show="pageBusy" variant="transparent">
        <b-card>
            <div class="row pt-0">
                <div class="col-12 pb-1">
                    <span class="font-weight-bolder">Filters</span>
                </div>
                <div class="col-lg-3 col-12 col-md-6">
                    <label>Date Range</label>
                    <flat-pickr
                        v-model="range"
                        class="form-control"
                        :config="{ mode: 'range'}"
                        />
                </div>
                <!-- <div class="col-lg-3 col-12 col-md-6">
                    <label>Mode</label>
                    <v-select  v-model="mode"  :options="modeOptions" :clearable="false"></v-select>
                </div> -->
                <!-- <div class="col-lg-3 col-12 col-md-6" v-if="mode && mode.value != 'draft'">
                    <label>Fundraiser Types</label>
                    <v-select  v-model="featuredOption" :reduce="e=>e.value" :options="featuredOptions" :searchable="false" :clearable="false"></v-select>
                </div>
                <div class="col-lg-3 col-12 col-md-6" v-if="mode && mode.value != 'draft'">
                    <label>Visibility</label>
                    <v-select  v-model="visible" :reduce="e=>e.value" :options="visibleOptions" :searchable="false" :clearable="false"></v-select>
                </div> -->
                <div class="col-lg-3 col-12 col-md-6">
                    <label>State</label>
                    <v-select  v-model="status" :options="statusOptions"></v-select>
                </div>
                <div class="col-lg-3 col-12 col-md-6">
                    <label>Visibility</label>
                    <v-select v-model="visible" :options="visibleOptions" :clearable="false"></v-select>
                </div>
                <div class="col-lg-3 col-12 col-md-6">
                    <label>Content edits</label>
                    <v-select v-model="pendingEditOption" :options="pendingEditOptions" :clearable="false"></v-select>
                </div>
                <div class="col-lg-3 col-12 col-md-6">
                    <label>Fundraiser title</label>
                    <input v-model="searchTitle" type="text" class="form-control" placeholder="">
                </div>
                <div class="col-lg-3 col-12 col-md-6">
                    <label>Creator id</label>
                    <input v-model="userId" type="text" class="form-control" placeholder="">
                </div>
                <div class="col-lg-3 col-12 col-md-6">
                    <label>Charity name</label>
                    <input v-model="searchCharity" type="text" class="form-control" placeholder="Partial name (EN or FR)" @keyup.enter="filterFeedback()">
                </div>
                <div class="col-lg-3 col-12 col-md-6 pt-2 pt-lg-2" @click="filterFeedback()">
                    <span class="btn btn-primary"> <feather-icon icon="SearchIcon" /> Search</span>
                </div>
            </div>
        </b-card>
        <b-card>
            <b-overlay :show="itemBusy">
                <b-table
                    class="rounded border"
                    :items="items"
                    :fields="fields"
                    :per-page="10"
                    :current-page="1"
                    responsive
                >

                    <template #head()="scope">
                        <div class="text-nowrap text-primary">
                        {{ scope.label }}
                        </div>
                    </template>
                    <template #cell(target)="data">
                        <span class="text-nowrap badge badge-primary" v-if="data.item._id">
                           {{fundraiserTargets[data.item.fundraiserType]}}
                        </span>
                    </template>
                    <template #cell(charity)="data">
                        <template v-if="data.item._id || data.item.id">
                            <template v-if="isCharityFundraiser(data.item)">
                                <div
                                    v-for="(charity, idx) in resolveCharities(data.item)"
                                    :key="charity.id || `name-${idx}`"
                                    class="text-nowrap mb-25"
                                >
                                    <router-link
                                        v-if="charity.id"
                                        :to="charityDetailsRoute(charity)"
                                        class="font-weight-bolder"
                                        :title="`View charity ${charity.id}`"
                                    >
                                        {{ charityDisplayName(charity) }}
                                    </router-link>
                                    <span v-else class="font-weight-bolder">{{ charityDisplayName(charity) }}</span>
                                    <b-badge v-if="charity.missing" variant="light" class="ml-25">not found</b-badge>
                                    <b-badge v-else-if="charity.isDeleted" variant="danger" class="ml-25">deleted</b-badge>
                                    <div v-if="charity.id"><small class="text-muted">{{ charity.id }}</small></div>
                                </div>
                                <small v-if="!resolveCharities(data.item).length" class="text-muted font-italic">No charity linked</small>
                            </template>
                            <span v-else class="text-muted">—</span>
                        </template>
                    </template>
                    <template #cell(title)="data">
                        <span class="three-line-ellipsis" v-if="data.item._id">
                           {{data.value}}
                        </span>
                        <div v-else class="pt-2">
                        
                        </div>
                    </template>
                    <template #cell(creator)="data">
                        <template v-if="data.item._id || data.item.id">
                            <div class="text-nowrap">{{ data.item.creatorName || '—' }}</div>
                            <small class="text-muted">{{ data.item.createdBy }}</small>
                        </template>
                    </template>
                    <template #cell(status)="data">
                        <template v-if="data.item._id || data.item.id">
                            <b-badge :variant="displayStatus[1][data.item.status] || 'secondary'">
                                {{ displayStatus[0][data.item.status] || 'Unknown' }}
                            </b-badge>
                            <b-badge
                                v-if="data.item.hasPendingEdit || (data.item.pendingEdit && data.item.pendingEdit.status === 'pending')"
                                variant="warning"
                                class="ml-50"
                            >
                                Content edit pending
                            </b-badge>
                            <b-badge
                                v-if="data.item.awaitingCharityPublication"
                                variant="warning"
                                class="ml-50"
                            >
                                Awaiting charity approval
                            </b-badge>
                        </template>
                    </template>
                    <template #cell(visibility)="data">
                        <span class="text-nowrap" v-if="data.item._id">
                            <b-badge variant="danger" v-if="!data.item.isVisible">
                                Disabled
                            </b-badge>
                            <b-badge variant="success" v-else>
                                Public
                            </b-badge>
                            <div  v-if="data.item.isFeatured" class="mt-1">
                                <b-badge variant="dark">
                                    Is a featured fundraiser
                                </b-badge>
                            </div>
                        </span>
                    </template>
                    <template #cell()="data">
                        <div class="text-nowrap small pt-1">
                            {{data.value}}
                        </div>
                    </template>
                    <template #cell(businessType)="data">
                        <div class="text-nowrap pt-1 small" v-if="data.item._id">
                            {{data.value == 3? 'Corporate Business': 'Private Business'}}
                        </div>
                    </template>
                    <template #cell(createdAt)="data">
                        <div class="text-nowrap pt-1" v-if="data.item._id">
                            {{ dayjs(data.value).format("MMM D, YYYY h:mm A") }}
                        </div>
                    </template>
                    <template #cell(updatedAt)="data">
                        <div class="text-nowrap pt-1" v-if="data.item._id">
                            {{ dayjs(data.value).format("MMM D, YYYY h:mm A") }}
                        </div>
                    </template>
                    <template #cell(actions)="data">
                        <!-- <div class="text-nowrap" v-if="data.item._id">
                            <b-button size="sm" pill variant="outline-primary" v-b-toggle.validate @click="triggerProcessing(data.item)">
                        Review
                            </b-button>
                        </div> -->

                        <b-dropdown
                            size="lg"
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            v-if="data.item._id"
                        >
                            <template #button-content>
                                <feather-icon
                                    icon="MoreVerticalIcon"
                                ></feather-icon>
                            </template>
                            <!-- <b-dropdown-item :to="`/users/list?user=${data.item.createdBy}`">
                                <feather-icon
                                    icon="UserIcon"
                                />
                                See creator
                            </b-dropdown-item> -->
                            <b-dropdown-item
                                v-for="charity in resolveCharities(data.item).filter(c => c.id)"
                                :key="`see-charity-${charity.id}`"
                                :to="charityDetailsRoute(charity)"
                            >
                                <feather-icon
                                    icon="HeartIcon"
                                />
                                See charity: {{ charityDisplayName(charity) }}
                            </b-dropdown-item>
                            <b-dropdown-item :to="`/transactions/donations?fundraiserId=${data.item.id}`" v-if="mode.value != 'draft'">
                                <feather-icon
                                    icon="NoteIcon"
                                />
                                See donations
                            </b-dropdown-item>
                            <b-dropdown-item @click="toggleVisibility(data.item)">
                                <feather-icon
                                    :icon="data.item.isVisible ? 'EyeOffIcon': 'EyeIcon'"
                                />
                                {{ data.item.isVisible ? 'Disable fundraiser' : 'Enable fundraiser' }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="openStaffPreview(data.item)">
                                <feather-icon
                                    icon="EyeIcon"
                                />
                                Preview
                            </b-dropdown-item>
                            <b-dropdown-item v-if="data.item.status" @click="triggerProcessing(data.item)">
                                <feather-icon
                                    icon="CheckIcon"
                                />
                                Review fundraiser
                            </b-dropdown-item>
                            <!-- <b-dropdown-item v-if="data.item.status == statuses.pending" @click="triggerProcessing(data.item)">
                                <feather-icon
                                    icon="CheckIcon"
                                />
                                Review fundraiser
                            </b-dropdown-item> -->
                            <b-dropdown-item
                                v-if="$can('update', 'Fundraisers')"
                                variant="danger"
                                @click="confirmDelete(data.item)"
                            >
                                <feather-icon
                                    icon="TrashIcon"
                                />
                                Delete fundraiser
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>
                    <template #cell(coverPhoto)="data">
                        <span class="text-nowrap" v-if="data.item.id">
                            <b-img :src="data.value" style="height: 50px" rounded class="cursor-pointer" @click="triggerViewImage([data.value])">

                            </b-img>
                        </span>
                    </template>
                </b-table>
            </b-overlay>
            <b-modal
                v-model="staffPrompt.visible"
                :title="staffPrompt.title"
                :ok-title="staffPrompt.okTitle"
                cancel-title="Cancel"
                centered
                @ok="confirmStaffPrompt"
            >
                <label class="d-block">{{ staffPrompt.label }}</label>
                <b-form-textarea
                    v-if="staffPrompt.multiline"
                    v-model="staffPrompt.value"
                    rows="3"
                    :placeholder="staffPrompt.label"
                />
                <b-form-input
                    v-else
                    v-model="staffPrompt.value"
                    :placeholder="staffPrompt.label"
                    autocomplete="one-time-code"
                />
            </b-modal>
            <b-modal id="view-images" ok-only hide-header size="lg" centered no-close-on-backdrop no-close-on-esc body-bg-variant="dark">
                <div style="min-height: 400px;">
                    <b-carousel id="carousel-main" style="text-shadow: 0px 0px 2px #000" :interval="7000" :controls="images.length > 1" :indicators="images.length>1" img-height="480px">
                        <b-carousel-slide  v-for="(item, index) in images" :key="index" :text="`${item}`" :img-src="item" />
                    </b-carousel>
                </div>
            </b-modal>
            <b-modal id="view-fundraiser" ok-only title="View Fundraiser Detail" size="xl" centered no-close-on-backdrop no-close-on-esc>
               <div class="row">
                   <div class="col-12" style="min-height: 600px;">
                       <iframe
                         v-if="previewFrameUrl"
                         class="w-100"
                         height="100%"
                         :src="previewFrameUrl"
                         frameborder="0"
                       ></iframe>
                       <div v-else class="p-2 text-muted">
                         Select a fundraiser to preview.
                       </div>
                   </div>
               </div>
            </b-modal>
            <div class="d-flex p-1">
                <div class="w-100">
                    Page <span class="text-primary"> {{currentPage}}</span> of <span class="text-primary">{{Math.ceil(totalRows/10)}}</span>
                </div>
                <div class="w-100">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="10"
                        aria-controls="users-table"
                        align="right"
                        size="sm"
                        class="my-0"
                        @page-click="loadNewPage"
                    />
                </div>
            </div>
            <b-sidebar
                shadow
                id="validate"
                sidebar-class="sidebar-lg"
                bg-variant="white"
                backdrop
                v-model="showSidebar"
                right
                title="Fundraiser Approval"
                title-background="primary"
                no-close-on-backdrop
                >
                <template #footer="{  }">
                    <div class="d-flex bg-dark text-light align-items-center p-1">
                        <!-- @@TODO Make the address dynamic on production  -->
                        <b-button variant="primary" @click="openStaffPreviewModal()">View Full Fundraiser Details</b-button>
                        <b-button variant="outline-light" class="ml-50" @click="openStaffPreview()">Open in new tab</b-button>
                    </div>
                </template>
                <template #default="{ hide }">
                    <div>
                        <div class="p-2 border-bottom border-top">
                            <h4 class="text-primary">Fundraiser Information</h4>
                            <h5 class="font-weight-bolder">Title</h5>
                            <span>{{account.title}}</span>
                            <h5 class="font-weight-bolder">Created by</h5>
                            <span>{{ account.creatorName || '—' }}</span>
                            <div v-if="account.createdBy"><small class="text-muted">User id: {{ account.createdBy }}</small></div>
                            <template v-if="isCharityFundraiser(account)">
                                <h5 class="font-weight-bolder">Charity</h5>
                                <div v-for="(charity, idx) in resolveCharities(account)" :key="`sidebar-charity-${charity.id || idx}`" class="mb-50">
                                    <router-link v-if="charity.id" :to="charityDetailsRoute(charity)" class="font-weight-bolder">
                                        {{ charityDisplayName(charity) }}
                                    </router-link>
                                    <span v-else class="font-weight-bolder">{{ charityDisplayName(charity) }}</span>
                                    <b-badge v-if="charity.missing" variant="light" class="ml-25">not found</b-badge>
                                    <b-badge v-else-if="charity.isDeleted" variant="danger" class="ml-25">deleted</b-badge>
                                    <div v-if="charity.id"><small class="text-muted">Charity id: {{ charity.id }}</small></div>
                                </div>
                                <span v-if="!resolveCharities(account).length" class="text-muted font-italic">No charity linked</span>
                                <h5 class="font-weight-bolder mt-1">Payout</h5>
                                <span>{{ payoutPlanLabel(account) }}</span>
                                <div v-if="account.disbursementAllocations && account.disbursementAllocations.length" class="mt-50">
                                    <div
                                        v-for="row in account.disbursementAllocations"
                                        :key="row.charityId"
                                        class="small"
                                    >
                                        {{ charityNameById(account, row.charityId) }} — {{ currency(row.amount || 0) }} USD
                                    </div>
                                </div>
                                <div v-else-if="canDisburseCharity(account)" class="mt-1">
                                    <b-button size="sm" variant="primary" @click="disburseFunds(account)">
                                        Record disbursement
                                    </b-button>
                                </div>
                                <p v-if="account.awaitingCharityPublication" class="small text-warning mt-50 mb-0">
                                    Gively has approved this fundraiser. It stays hidden until the charity approves it.
                                </p>
                            </template>
                            <h5 class="font-weight-bolder">Country</h5>
                            <span v-if="account && account.country">{{account.country.nameEn}}</span>
                            <h5 class="font-weight-bolder">Target amount</h5>
                            <span v-if="account.targetAmount">{{currency(account.targetAmount)}} CAD</span>
                            <h5 class="font-weight-bolder">Current amount</h5>
                            <span v-if="account.currentAmount">{{currency(account.currentAmount)}} CAD</span>
                            <div>
                                <h5 class="font-weight-bolder">Allow recommendations</h5>
                                <span>{{account.allowRecommendation ? 'Yes' : 'No'}}</span>
                            </div>
                            <div>
                                <h5 class="font-weight-bolder">Disable search</h5>
                                <span>{{account.disableSearch ? 'Yes' : 'No'}}</span>
                            </div>
                            <div>
                                <h5 class="font-weight-bolder">Is Featured fundraiser</h5>
                                <span>{{account.isFeatured ? 'Yes' : 'No'}}</span>
                            </div>
                            <div>
                                <h5 class="font-weight-bolder">Is visible</h5>
                                <b-badge :variant="account.isVisible ? 'success' : 'secondary'">{{account.isVisible ? 'Yes' : 'No'}}</b-badge>
                                <div class="mt-1">
                                    <b-button
                                        size="sm"
                                        :variant="account.isVisible ? 'danger' : 'success'"
                                        @click="toggleVisibility(account)"
                                    >
                                        {{ account.isVisible ? 'Disable fundraiser' : 'Enable fundraiser' }}
                                    </b-button>
                                </div>
                                <p class="small text-muted mt-1 mb-0">
                                    Disabled fundraisers are hidden from the public and only visible to staff and the creator.
                                </p>
                            </div>
                            <h5 class="font-weight-bolder mt-2">Banner</h5>
                            <b-img rounded style="max-height: 400px; max-width: 100%" :src="account.coverPhoto" class="cursor-pointer" @click="triggerViewImage([account.coverPhoto])">

                            </b-img>
                            <h5 class="font-weight-bolder mt-2">Story</h5>
                            <safe-rich-text :html="account.story" />
                            <h5 class="font-weight-bolder mt-2">Gallery</h5>
                            <div>
                                <div class="d-inline-block mr-1" v-for="item in account.gallery" :key="item">
                                    <b-img :src="item" rounded height="100px" class="cursor-pointer" @click="triggerViewImage(account.gallery)">

                                    </b-img>
                                </div>
                            </div>

                            <div
                              v-if="account.pendingEdit && (account.pendingEdit.status === 'pending' || account.pendingEdit.status === 'rejected')"
                              class="mt-3 pt-3 border-top"
                            >
                              <h4 class="text-warning">
                                Pending content edit
                                <b-badge :variant="account.pendingEdit.status === 'pending' ? 'warning' : 'danger'">
                                  {{ account.pendingEdit.status }}
                                </b-badge>
                              </h4>
                              <p class="small text-muted mb-2">
                                Live version remains public. Approve to replace story and images with this draft.
                              </p>
                              <h5 class="font-weight-bolder mt-2">Proposed banner</h5>
                              <b-img
                                v-if="account.pendingEdit.coverPhoto"
                                rounded
                                style="max-height: 300px; max-width: 100%"
                                :src="account.pendingEdit.coverPhoto"
                                class="cursor-pointer"
                                @click="triggerViewImage([account.pendingEdit.coverPhoto])"
                              />
                              <h5 class="font-weight-bolder mt-2">Proposed story</h5>
                              <safe-rich-text :html="account.pendingEdit.story" />
                              <h5 class="font-weight-bolder mt-2">Proposed gallery</h5>
                              <div>
                                <div class="d-inline-block mr-1" v-for="item in (account.pendingEdit.gallery || [])" :key="item">
                                  <b-img :src="item" rounded height="100px" class="cursor-pointer" @click="triggerViewImage(account.pendingEdit.gallery)" />
                                </div>
                              </div>
                              <div v-if="account.pendingEdit.rejectionMessage" class="alert alert-danger mt-2 mb-0">
                                {{ account.pendingEdit.rejectionMessage }}
                              </div>
                            </div>

                            <div
                              v-if="account.fundraiserType && account.fundraiserType != 10"
                              class="mt-3 pt-3 border-top"
                            >
                              <h4 class="text-primary">Disbursement &amp; KYC</h4>
                              <h5 class="font-weight-bolder">Fundraiser for</h5>
                              <span>{{ fundraiserTargets[String(account.fundraiserType)] || 'Unknown' }}</span>
                              <h5 class="font-weight-bolder mt-2">KYC subject</h5>
                              <span>{{ account.kyc && account.kyc.subjectType === 'beneficiary' ? 'Beneficiary' : 'Organizer' }}</span>
                              <h5 class="font-weight-bolder mt-2">KYC status</h5>
                              <b-badge variant="info">{{ formatKycStatus(account.kyc && account.kyc.status) }}</b-badge>
                              <h5 class="font-weight-bolder mt-2">Disbursement status</h5>
                              <span>{{ formatDisbursementStatus(account.disbursementStatus) }}</span>
                              <h5 class="font-weight-bolder mt-2">Disbursed amount</h5>
                              <span>{{ currency(account.disbursedAmount || 0) }} USD</span>

                              <div v-if="account.kyc && account.kyc.beneficiary" class="mt-2">
                                <h5 class="font-weight-bolder">Beneficiary profile</h5>
                                <div class="small">
                                  <div v-if="account.kyc.beneficiary.legalFirstName || account.kyc.beneficiary.legalLastName">
                                    Name: {{ account.kyc.beneficiary.legalFirstName }} {{ account.kyc.beneficiary.legalLastName }}
                                  </div>
                                  <div v-if="account.kyc.beneficiary.email">Email: {{ account.kyc.beneficiary.email }}</div>
                                  <div v-if="account.kyc.beneficiary.phone">Phone: {{ account.kyc.beneficiary.phone }}</div>
                                  <div v-if="account.kyc.beneficiary.relationshipToOrganizer">
                                    Relationship: {{ account.kyc.beneficiary.relationshipToOrganizer }}
                                  </div>
                                  <div v-if="account.kyc.beneficiary.bankAccountHolderName">
                                    Bank account: {{ account.kyc.beneficiary.bankAccountHolderName }}
                                    <span v-if="account.kyc.beneficiary.bankAccountNumberLast4">
                                      (****{{ account.kyc.beneficiary.bankAccountNumberLast4 }})
                                    </span>
                                  </div>
                                  <div v-if="account.kyc.beneficiary.bankName">Bank: {{ account.kyc.beneficiary.bankName }}</div>
                                </div>
                              </div>

                              <div class="d-flex flex-wrap gap-2 mt-3">
                                <b-button
                                  size="sm"
                                  variant="success"
                                  :disabled="!(account.kyc && account.kyc.status === 'submitted')"
                                  @click="approveKyc(account)"
                                >
                                  Approve KYC
                                </b-button>
                                <b-button
                                  size="sm"
                                  variant="warning"
                                  :disabled="!(account.kyc && account.kyc.status === 'submitted')"
                                  @click="rejectKyc(account)"
                                >
                                  Reject KYC
                                </b-button>
                                <b-button
                                  size="sm"
                                  variant="primary"
                                  :disabled="!canDisburse(account)"
                                  @click="disburseFunds(account)"
                                >
                                  Disburse funds
                                </b-button>
                              </div>
                            </div>

                            <div v-if="account.businessType == 3">
                                <h5 class="font-weight-bolder mt-1">
                                    Registration Documents
                                </h5>
                                <b-list-group>
                                    <b-list-group-item v-for="(i,j) in account.regDocument" :key="j">
                                        <a :href="i" target="_blank" class="d-block">
                                            <b-img fluid rounded :src="i" v-if="i.includes('.png') || i.includes('.gif') || i.includes('.jpeg') || i.includes('.jpg')"></b-img>
                                            <small class="text-muted text-nowrap d-block mt-1 text-truncate">
                                                {{i}}
                                            </small>
                                        </a>
                                    </b-list-group-item>
                                </b-list-group>
                            </div>

                            <div v-if="account.status !=5 && account.status !=-5">
                                <h4 class="text-primary mt-2 pt-2 border-top">Add review</h4>
                                <p class="small text-muted" v-if="account.pendingEdit && account.pendingEdit.status === 'pending'">
                                    This fundraiser has a pending content edit. Approving applies the draft to the live page. Declining keeps the live page and lets the creator revise the draft.
                                </p>
                                <div class="d-flex justify-content-between">
                                    <b-form-radio v-model="applicationStatus" value="1">
                                        Approve
                                    </b-form-radio>
                                    <b-form-radio v-model="applicationStatus" value="2">
                                        Decline
                                    </b-form-radio>
                                    <b-form-radio v-model="applicationStatus" value="3">
                                        Decline permanently
                                    </b-form-radio>
                                </div>
                                <div v-if="applicationStatus > 1" class="mt-1">
                                    <div>
                                        <label class="mt-2"> Reason </label>
                                        <b-textarea v-model="user.text">
                                        </b-textarea>
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <b-button rounded variant="primary" @click="addReview(hide)" :disabled="!applicationStatus || (applicationStatus > 1 && (!user.text.trim().length))">
                                        Submit
                                    </b-button>
                                </div>
                            </div>
                        </div>
                        <h4 class="p-2 text-primary" v-if="account.reviewHistory && account.reviewHistory.length">Review history</h4>
                        <b-list-group>
                            <b-list-group-item v-for="(review, j) in account.reviewHistory" :key="j">
                                <div class="alert alert-secondary rounded p-1 mb-0">
                                    <div>
                                        <b-badge :variant="displayStatus[1][review.status]">
                                            {{ displayStatus[0][review.status] }}
                                        </b-badge>
                                        <b-badge v-if="review.reviewType" variant="light" class="ml-50">
                                            {{ review.reviewType }}
                                        </b-badge>
                                    </div>
                                    {{review.message}}
                                </div>
                                <div class="d-flex p-0">
                                    <div class="w-100">
                                        <small>{{review.reviewedBy || review.reviewer}}</small>
                                    </div>
                                    <div class="text-right text-nowrap">
                                        <small class="text-primary">
                                            {{ dayjs(review.reviewDate || review.time).format("MMM D, YYYY h:mm A") }}
                                        </small>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </template>
            </b-sidebar>
        </b-card>
    </b-overlay>


</template>

<script>

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import dayjs from "dayjs";
import flatPickr from 'vue-flatpickr-component'
import Utils from '@/utils/index';
import baseUrl from '@/services/baseUrl'
import commonApi from '@/services/api'
import SafeRichText from '@/components/SafeRichText.vue'
import API from './api'
import Fundraiser from './SingleFundraiser.vue'

const toast = useToast()
export default {
    name: 'Feedback',
    components: {
        flatPickr,
        vSelect,
        Fundraiser,
        SafeRichText,
    },
    data() {
        return {
            fundraiserTargets:{
                '1': 'Yourself',
                '5': 'Someone else',
                '10': 'Charity',
                // rejected: -10,
            },
            staffPrompt: {
                visible: false,
                title: '',
                label: '',
                okTitle: 'Confirm',
                multiline: false,
                value: '',
                onSubmit: null,
            },
            link: baseUrl.website,
            previewFrameUrl: '',
            stagingLink: baseUrl.website,
            dayjs: dayjs,
            currentPage: 1,
            totalRows: 10,
            range: '',
            reviews: [],
            searchDate: '',
            dateRange: '',
            searchTitle: '',
            searchCharity: '',
            status: '',
            statuses: Object.freeze({
                pending: 10,
                paused: 20,
                running: 30,
                ended: 40,
                cancelled: -30,
                rejected: -10,
                rejectedPermanently: -100,
            }),
            displayStatus:[
                {
                    10: "Pending",
                    20: "Paused",
                    30: "Running",
                    40: "Ended",
                    '-30': "Cancelled",
                    '-10': "Rejected",
                    '-100': "Rejected permanently",
                },
                {
                    10: "dark",
                    20: "warning",
                    30: "success",
                    40: "primary",
                    '-30': "danger",
                    '-10': "danger",
                    '-100': "danger",
                },
            ],
            statusOptions: [
                {label:'Pending review',"value":10},
                {label:'Paused',"value":20},
                {label:'Running',"value":30},
                {label:'Ended',"value":40},
                {label:'Canceled',"value":-30},
                {label:'Rejected',"value":-10},
                {label:'Rejected permanently',"value":-100},
            ],
            pendingEditOption: '',
            pendingEditOptions: [
                {label:'All', value: ''},
                {label:'Has pending content edit', value: true},
            ],
            modeOptions: [
                {label:'Published',"value":'submitted'},
                {label:'Draft',"value": 'draft'},
            ],
            featuredOption: '',
            featuredOptions: [
                {label:'All', value: ''},
                {label:'Featured', value: true}
            ],
            visible: '',
            userId: '',
            visibleOptions: [
                {label:'All', value: ''},
                {label:'Public (enabled)', value: true},
                {label:'Disabled (staff/creator only)', value: false}
            ],
            mode: '',
            user: {
                text:'',
                status: '',
                id: ''
            },
            account: {
                reviewHistory: []
            },
            checked: '',
            images: [],
            feedbackOptions: [
                {label:'Invalid story',"value":1},
                {label:'Inappropriate coverPhoto',"value": 2},
                {label:'Video too long',"value": 3},
                {label:'Inappropriate Title',"value": 4},
                {label:'Others ',"value": 5},
                ],
            items: [],
            fields: [
                {key: 'actions', label: 'Actions'},
                {key: 'title', label: 'Title'},
                {key: 'creator', label: 'Created by'},
                {key: 'visibility', label: 'Visibility'},
                {key: 'status', label: 'Running Status'},
                {key: 'target', label: 'Target'},
                {key: 'charity', label: 'Charity'},
                // {key: 'shortDesc', label: 'Description'},
                {key: 'coverPhoto', label: 'Banner'},
                {key: 'createdAt', label: 'Created At'},
                {key: 'updatedAt', label: 'Updated At'},
            ],
            pendingFields: [
                {key: 'actions', label: 'Actions'},
                {key: 'id', label: 'ID'},
                {key: 'title', label: 'Title'},
                {key: 'creator', label: 'Created by'},
                {key: 'visibility', label: 'Visibility'},
                {key: 'status', label: 'Running Status'},
                {key: 'target', label: 'Target'},
                {key: 'charity', label: 'Charity'},
                // {key: 'shortDesc', label: 'Description'},
                {key: 'coverPhoto', label: 'Banner'},
                {key: 'createdAt', label: 'Created At'},
                {key: 'updatedAt', label: 'Updated At'},
            ],
            approvedFields: [
                {key: 'actions', label: 'Actions'},
                {key: 'title', label: 'Title'},
                {key: 'creator', label: 'Created by'},
                {key: 'status', label: 'Running Status'},
                {key: 'type', label: 'Type'},
                {key: 'charity', label: 'Charity'},
                {key: 'coverPhoto', label: 'Banner'},
                {key: 'createdAt', label: 'Created At'},
                {key: 'updatedAt', label: 'Updated At'},
            ],
            searchParams: {},
            itemBusy: false,
            pageBusy: false,
            showSidebar: false,
            applicationStatus: 0,
        }
    },
    computed: {
        websiteLink(){
            return baseUrl.website;
        }
    },
    watch: {
        range(newRange, oldRange) {
            newRange = newRange.split(' to ');
            if(newRange.length === 2) {
                this.searchDate = {
                    from: newRange[0],
                    to: newRange[1]
                }
            }else if(newRange[0].length == 10) {
                 this.searchDate = {
                    from: newRange[0],
                    to: newRange[0]
                }
            }else {
                this.searchDate = '';
            }
        },
        applicationStatus(data) {
            if(data == 1) {
                this.user.status = {
                    value: 3,
                    label: 'Run',
                }
                this.user.text = '';
            }else{
                this.user.status = '';
            }
        },
        mode(data){
            if(data && data.value == 'draft'){
                this.fields = this.approvedFields
            }else{
                this.fields = this.pendingFields
            }
            this.setStates();
            this.filterFeedback();
        }
    },
    created() {
        this.items = Utils.completeTable();
        const  { user, charity } = this.$route.query;
        if(user){
            this.userId = user;
        }
        if(typeof charity === 'string' && charity){
            this.searchCharity = charity;
        }
        // this.getFundraisers();
    },
    mounted() {
        this.mode = this.modeOptions[0];
        this.pendingEditOption = this.pendingEditOptions[0];
        this.visible = this.visibleOptions[0];
        this.setStates();
        this.filterFeedback();
    },
    methods: {
        currency: Utils.formatCurrency,
        resolveFundraiserId(item = {}) {
            return item.id || item._id || '';
        },
        isCharityFundraiser(item = {}) {
            return Number(item && item.fundraiserType) === 10;
        },
        /**
         * Charities linked to a fundraiser. Prefers the live records resolved by
         * the API (`charities`), falls back to the ids/names snapshot on the row.
         */
        resolveCharities(item = {}) {
            if (!item) return [];
            if (Array.isArray(item.charities) && item.charities.length) {
                return item.charities;
            }
            const ids = [...new Set([item.charityId, ...(item.charityIds || [])].filter(Boolean))];
            const names = Array.isArray(item.charityNames) ? item.charityNames.filter(Boolean) : [];
            if (!ids.length) {
                return names.map(name => ({ id: '', nameEn: name, nameFr: '', missing: true }));
            }
            return ids.map((id, index) => ({ id, nameEn: names[index] || '', nameFr: '', missing: false }));
        },
        charityDisplayName(charity = {}) {
            return charity.nameEn || charity.nameFr || charity.id || 'Charity';
        },
        charityDetailsRoute(charity = {}) {
            return { path: '/charities/manage', query: { search: charity.id } };
        },
        async issuePreviewUrl(item = {}) {
            const fundraiser = item && (item.permaLink || item.id || item._id)
              ? item
              : this.account;
            const site = this.websiteLink || this.link || '';
            if (!site || !fundraiser) return '';
            const id = this.resolveFundraiserId(fundraiser);
            const permalink = fundraiser.permaLink;
            let previewCode = '';
            try {
                const resp = await API.issuePreviewToken({ fundraiserId: id || '' });
                previewCode = (resp && resp.data && resp.data.previewCode) || '';
            } catch (error) {
                this.showToast('Could not create a preview link', 'InfoIcon', 'warning');
                return '';
            }
            if (!previewCode) {
                this.showToast('Could not create a preview link', 'InfoIcon', 'warning');
                return '';
            }
            const withToken = url => {
                const sep = url.includes('?') ? '&' : '?';
                return `${url}${sep}previewCode=${encodeURIComponent(previewCode)}`;
            };
            if (id) {
                return withToken(`${site}/preview-fundraiser/data-only/fundraiser?id=${encodeURIComponent(id)}&mode=submitted`);
            }
            if (permalink) {
                return withToken(`${site}/fundraiser/${permalink}`);
            }
            return '';
        },
        async prepareStaffPreview(item) {
            if (item && (item.permaLink || item.id || item._id)) {
                this.account = item;
            }
            this.previewFrameUrl = '';
            const url = await this.issuePreviewUrl(this.account);
            this.previewFrameUrl = url;
            return url;
        },
        async openStaffPreview(item) {
            const url = await this.prepareStaffPreview(item);
            if (url) window.open(url, '_blank');
        },
        async openStaffPreviewModal(item) {
            if (item && (item.permaLink || item.id || item._id)) {
                this.account = item;
            }
            if (!this.resolveFundraiserId(this.account) && !this.account?.permaLink) {
                this.showToast('Missing fundraiser id for preview', 'InfoIcon', 'warning');
                return;
            }
            await this.prepareStaffPreview(this.account);
            this.$bvModal.show('view-fundraiser');
        },
        formatKycStatus(status) {
            const map = {
                not_started: 'Not started',
                submitted: 'Submitted — pending review',
                approved: 'Approved',
                rejected: 'Rejected',
            };
            return map[status] || status || 'Not started';
        },
        formatDisbursementStatus(status) {
            const map = {
                none: 'None',
                pending_kyc: 'Pending KYC',
                kyc_in_review: 'KYC in review',
                ready: 'Ready to disburse',
                disbursed: 'Disbursed',
            };
            return map[status] || status || 'None';
        },
        canDisburse(item) {
            return (
                item
                && !this.isCharityFundraiser(item)
                && item.kyc
                && item.kyc.status === 'approved'
                && item.disbursementStatus !== 'disbursed'
                && Number(item.currentAmount || 0) > 0
            );
        },
        canDisburseCharity(item) {
            return (
                this.isCharityFundraiser(item)
                && item.disbursementStatus !== 'disbursed'
                && Number(item.currentAmount || 0) > 0
            );
        },
        charityNameById(item, charityId) {
            const match = this.resolveCharities(item).find(charity => charity.id === charityId);
            return match ? this.charityDisplayName(match) : (charityId || 'Charity');
        },
        payoutPlanLabel(item = {}) {
            const charities = this.resolveCharities(item);
            const ids = [...new Set([item.charityId, ...(item.charityIds || [])].filter(Boolean))];
            if (item.payoutMode === 'equal_split' && ids.length > 1) {
                return `Equal split among ${charities.map(charity => this.charityDisplayName(charity)).join(', ')}`;
            }
            const recipient = item.payoutCharityId || item.charityId;
            return `Full amount to ${this.charityNameById(item, recipient)}`;
        },
        approveKyc(item) {
            this.itemBusy = true;
            API.reviewFundraiserKyc({ id: this.resolveFundraiserId(item), status: 'approved' }).then(res => {
                if (res.success) {
                    this.account = res.data;
                    this.$bvToast.toast('KYC approved', { variant: 'success' });
                    this.filterFeedback();
                }
            }).finally(() => {
                this.itemBusy = false;
            });
        },
        openStaffPrompt({ title, label, okTitle, multiline, onSubmit }) {
            this.staffPrompt = {
                visible: true,
                title,
                label,
                okTitle,
                multiline,
                value: '',
                onSubmit,
            };
        },
        confirmStaffPrompt(event) {
            const value = (this.staffPrompt.value || '').trim();
            if (!value) {
                event.preventDefault();
                return;
            }
            const submit = this.staffPrompt.onSubmit;
            if (submit) submit(value);
        },
        rejectKyc(item) {
            this.openStaffPrompt({
                title: 'Reject KYC',
                label: 'Rejection reason for the organizer',
                okTitle: 'Reject',
                multiline: true,
                onSubmit: reason => {
                    this.itemBusy = true;
                    API.reviewFundraiserKyc({
                        id: this.resolveFundraiserId(item),
                        status: 'rejected',
                        rejectionReason: reason,
                    }).then(res => {
                        if (res.success) {
                            this.account = res.data;
                            this.$bvToast.toast('KYC rejected', { variant: 'warning' });
                            this.filterFeedback();
                        }
                    }).finally(() => {
                        this.itemBusy = false;
                    });
                },
            });
        },
        disburseFunds(item) {
            const amount = `${this.currency(item.currentAmount || 0)} USD`;
            const message = this.isCharityFundraiser(item)
                ? `Record disbursement of ${amount}. Donations stay in the Gively account until this payout. ${this.payoutPlanLabel(item)}.`
                : `Disburse ${amount} to the verified ${item.kyc?.subjectType === 'beneficiary' ? 'beneficiary' : 'organizer'}?`;
            this.$bvModal.msgBoxConfirm(
                message,
                {
                    title: 'Confirm disbursement',
                    okVariant: 'primary',
                    okTitle: 'Disburse',
                    cancelTitle: 'Cancel',
                },
            ).then(confirmed => {
                if (!confirmed) return;
                this.openStaffPrompt({
                    title: 'Confirm disbursement',
                    label: 'Enter your authenticator or recovery code',
                    okTitle: 'Confirm',
                    multiline: false,
                    onSubmit: code => {
                        this.itemBusy = true;
                        commonApi.staffStepUp({ code, recoveryCode: code }).then(step => {
                            if (!step || !step.success || !step.data || !step.data.stepUpCode) {
                                this.$bvToast.toast('Authenticator confirmation failed', { variant: 'danger' });
                                this.itemBusy = false;
                                return null;
                            }
                            return API.disburseFundraiser({
                                id: this.resolveFundraiserId(item),
                                stepUpCode: step.data.stepUpCode,
                            });
                        }).then(res => {
                            if (!res) return;
                            if (res.success && res.data && res.data.pendingApproval) {
                                this.account = res.data;
                                this.$bvToast.toast('Recorded. A different staff member must approve this disbursement.', { variant: 'warning' });
                                this.filterFeedback();
                                return;
                            }
                            if (res.success) {
                                this.account = res.data;
                                this.$bvToast.toast('Funds marked as disbursed', { variant: 'success' });
                                this.filterFeedback();
                            }
                        }).finally(() => {
                            this.itemBusy = false;
                        });
                    },
                });
            });
        },
        toggleVisibility(item){
            const isVisible = !item.isVisible;
            const actionLabel = isVisible ? 'enabled' : 'disabled';
            this.itemBusy = true;
            API.toggleVisibility({ isVisible }, this.resolveFundraiserId(item)).then(res=>{
                if(res.success) {
                    this.items = this.items.map(i=>{
                        if(i._id == item._id || i.id == item.id) {
                            return res.data;
                        }
                        return i
                    })
                    if (this.account && (this.account._id === item._id || this.account.id === item.id)) {
                        this.account = res.data;
                    }
                    this.$bvToast.toast(`Fundraiser ${actionLabel}`, { variant: 'success' });
                } else if (res.message) {
                    this.$bvToast.toast(res.message, { variant: 'danger' });
                }
            }).catch(e => {
                this.$bvToast.toast('Failed to update visibility', { variant: 'danger' });
            }).finally(() => {
                this.itemBusy = false;
            });
        },
        toggleFeatured(item){
            const isFeatured = item.isFeatured ? false : true;
            API.toggleFeatured({isFeatured}, this.resolveFundraiserId(item)).then(res=>{
                if(res.success) {
                    this.items = this.items.map(i=>{
                        if(i._id == item._id || i.id == item.id) {
                            i = res.data;
                        }
                        return i
                    })
                }
            }).catch(e => {
            });
        },
        setStates(){
            this.statusOptions = [
                {label:'Pending review',"value":10},
                {label:'Paused',"value":20},
                {label:'Running',"value":30},
                {label:'Ended',"value":40},
                {label:'Canceled',"value":-30},
                {label:'Rejected',"value":-10},
                {label:'Rejected permanently',"value":-100},
            ]
            this.status = this.statusOptions[0];
        },
        showFundraiser(data = {}) {
            // Guard against @click passing a DOM event as the first arg.
            if (data && (data.id || data._id || data.permaLink)) {
                this.account = data;
            }
            this.prepareStaffPreview(this.account);
            this.$bvModal.show('view-fundraiser');
        },
        openFundraiser(data = {}) {
            if (data && (data.id || data._id || data.permaLink)) {
                this.account = data;
            }
            this.prepareStaffPreview(this.account);
            this.$bvModal.show('view-fundraiser');
        },
        triggerViewImage(image = []) {
            this.images = image;
            this.$bvModal.show('view-images');
        },
        runFundraiser(e) {
            API.runFundraiser({id: this.account._id}).then(res=>{
                if(res.success) {
                    this.user.status = '';
                    this.user.text = '';
                    setTimeout(()=>{
                        this.getFundraisers(this.currentPage);
                    },200);
                    e();
                    this.showSidebar = false;
                    this.showToast('Fundraiser started successfully','CheckCircle','success');
                }
            }).catch(err=>{
            })
        },
        pauseFundraiser(e) {
            API.pauseFundraiser({id: this.account._id}).then(res=>{
                if(res.success) {
                    this.user.status = {};
                    this.user.text = '';
                    setTimeout(()=>{
                        this.getFundraisers(this.currentPage);
                    },200);
                    e();
                    this.showSidebar = false;
                    this.showToast('Fundraiser paused successfully','CheckCircle','success');
                }
            }).catch(err=>{
            })
        },
        confirmDelete(fundraiser) {
            const name = fundraiser.title || 'this fundraiser';
            this.$bvModal.msgBoxConfirm(
                `Are you sure you want to delete "${name}"?`,
                {
                    title: `Delete ${name}`,
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    centered: true,
                },
            ).then(value => {
                if (value) this.deleteFundraiser(fundraiser);
            });
        },
        deleteFundraiser(fundraiser) {
            const id = this.resolveFundraiserId(fundraiser);
            const name = fundraiser.title || 'this fundraiser';
            if (!id) {
                this.showToast('Missing fundraiser id — reload the list and try again', 'AlertCircle', 'danger');
                return;
            }
            this.itemBusy = true;
            API.deleteFundraiser(id).then(res => {
                if (!res.success) {
                    this.showToast(res.message || 'Failed to delete fundraiser');
                    return;
                }
                this.showToast(`"${name}" was deleted`, 'CheckCircle', 'success');
                const stillOnPage = this.items.some(item => {
                    const itemId = this.resolveFundraiserId(item);
                    return itemId && itemId !== id;
                });
                const page = stillOnPage ? this.currentPage : Math.max(1, this.currentPage - 1);
                this.getFundraisers(page);
            }).catch(() => {
                this.showToast();
            }).finally(() => {
                this.itemBusy = false;
            });
        },
        addReview(e) {
            // if(this.applicationStatus == 1){
            //     this.runFundraiser(e);
            //     return 0;
            // }
            const id = this.resolveFundraiserId(this.account);
            if (!id) {
                this.showToast('Missing fundraiser id — reload the list and try again', 'AlertCircle', 'danger');
                return;
            }
            const data = {
                id,
                message: '',
                status: this.applicationStatus == 1? 30:(this.applicationStatus == 2? -10: -100)
            }
            if(this.user.status.value == 5){
                data.message = this.user.text.trim();
            }else if(this.applicationStatus != 1){
                data.message = this.user.status.label + ". " + this.user.text.trim();
            }
            API.reviewFundraiser({...data}).then(res=>{
                if(res.success && res.data) {
                    this.resetReview();
                    setTimeout(()=>{
                        this.getFundraisers(this.currentPage);
                    },200);
                    e();
                    this.showToast(
                        res.data.awaitingCharityPublication
                            ? 'Approved by Gively. The charity must approve it before it is public.'
                            : 'Review Added successfully',
                        'CheckCircle',
                        res.data.awaitingCharityPublication ? 'warning' : 'success',
                    );
                } else {
                    this.showToast(res.message || 'Failed to review fundraiser', 'AlertCircle', 'danger');
                }
            }).catch(err=>{
                this.showToast('Failed to review fundraiser', 'AlertCircle', 'danger');
            })
        },
        resetReview(){
            this.user = {
                text:'',
                status: '',
                id: ''
            }
            this.applicationStatus = 0;
        },
        triggerProcessing(data) {
            this.account = data;
            this.user.id = this.resolveFundraiserId(data);
            this.showSidebar = true;
            // this.$bvModal.show('validate');
        },
        loadNewPage(e,page) {
            e.preventDefault();
            this.getFundraisers(page);
        },
        getFundraisers(page = 1) {
            // this.pageBusy = true;
            API.getFundraisers({
                ...this.searchParams,
                page,
                pageNum: page,
                mode: this.mode.value || 'submitted',
            }).then(res => {
                this.pageBusy = false;
                if(res.success && res.data) {
                    this.currentPage = res.data.currentPage;
                    this.items = Utils.completeTable(res.data.list);
                    this.totalRows = res.data.total || 10;
                }
            }).catch(() => {
                this.pageBusy = false;
                this.showToast();
            })
        },
         filterFeedback() {
        
            this.searchParams = {};
            if(this.searchTitle) {
                this.searchParams.title = this.searchTitle;
            }
            if(this.featuredOption) {
                this.searchParams.isFeatured = true;
            }
            if(this.userId) {
                this.searchParams.createdBy = this.userId;
            }
            if(this.searchCharity && this.searchCharity.trim()) {
                this.searchParams.charityName = this.searchCharity.trim();
            }
            if(this.visible && typeof this.visible.value === 'boolean') {
                this.searchParams.isVisible = this.visible.value;
            }
            if(this.status && this.status.value) {
                this.searchParams.status = this.status.value;
            }
            if(this.pendingEditOption && this.pendingEditOption.value === true) {
                this.searchParams.hasPendingEdit = true;
                // Content edits can exist on running fundraisers; don't force pending status.
                delete this.searchParams.status;
            }
            if(this.searchDate && this.searchDate.from) {
                this.searchParams.startDate = this.searchDate.from + ' 00:00:00';
                if(!this.searchDate.to) {
                    this.searchDate.to = this.searchDate.from
                }
                this.searchParams.endDate = this.searchDate.to + ' 23:59:59';
            }
            
            this.getFundraisers(1);
            this.currentPage = 1;
        },
        showToast(message, icon, variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message || 'Error fetching applications',
                    icon: icon || 'InfoIcon',
                    variant: variant || 'danger',
                },
            })
        },
        showModal(feedback) {
            this.$bvModal.msgBoxOk(feedback, {
            title: 'Feedback',
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            headerClass: 'p-2 border-bottom-0',
            bodyClass: 'text-break',
            footerClass: 'p-2 border-top-0',
            centered: true
            })
            .then(value => {
                this.feedback = value
            })
            .catch(err => {
                // An error occurred
            })
        },
        markAsProcessed(feedbackId) {
            if(feedbackId) {
                this.feedbacks = {};
                // this.pageBusy = true;
                API.markAsProcessed({_id: feedbackId}).then(res => {
                    this.pageBusy = false;
                    if(res.success) {
                        this.items = this.items.map(item =>{
                            if(item._id == feedbackId) {
                                item.status = res.data.status;
                            }
                            return item;
                        })
                        this.showToast('Feedback Marked as processed', 'CheckIcon', 'success');
                    }
                }).catch(() => {
                    this.pageBusy = false;
                    this.showToast('Error processing feedback')
                })
            }
        }
    }
}
</script>

<style lang="scss" scope>

    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/vue-flatpicker.scss';

    .feedback-content{

        max-width: 100px !important;
    }
    .feedback-content:hover{
        transform: scale(1.2);
    }
    #carousel-main{
        text-align: center !important;
        img{
            height: 480px !important;
            width: auto !important;
        }
    }
</style>